import StaffPanel from './StaffPanel'

export * from './StaffPanel'

export default StaffPanel
